import { motion } from 'framer-motion';
import { useRef, useState } from 'react';
import useDiaryMenuActions from '../../hooks/diary/useDiaryMenuActions';
import useHandleClickOutside from '../../hooks/utils/useHandleClickOutside';
import DiaryItemList from './DiaryItemList';
import DiarySum from './DiarySum';
import DiaryMenu from './DiaryMenu';

const DiarySectionItem = ({
    title,
    name = '',
    recipeSlug = null,
    time = '',
    iconSrc,
    bgColor = '#FFEFAF',
    items = [],
    entryType,
    mealId = null,
    favoriteId = null,
    isEmptySlot = false,
    displayIndex,
    slotIndex,
    isDuplicate = false,
    addMeal,
    isExercise = false,
    deletePlaceholder,
    deleteFavoriteMeal,
    isDeletingFavorite,
    isSectionOpen,
    onToggleSection,
    openModal
}) => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleButtonRef = useRef(null);
    const menuRef = useRef(null);

    useHandleClickOutside([menuRef, toggleButtonRef], menuOpen, setMenuOpen);

    // DERIVED

    const hasItems = items.length > 0;
    const shouldShowMenu = hasItems || (isDuplicate && !hasItems);

    const mealLabel = time ? `${time}${name ? ` - ${name}` : ''}` : name;
    const shouldShowLabel = Boolean(name || time);

    // HANDLERS

    const handleMenuToggle = (e) => {
        e.stopPropagation();
        setMenuOpen((prev) => !prev);
    };

    const handleMenuAction = useDiaryMenuActions({
        openModal,
        addMeal,
        deleteFavoriteMeal,
        deletePlaceholder,
        favoriteId,
        slotIndex
    });

    const handleMenuClick = (action) => {
        handleMenuAction({
            action,
            entryType,
            mealId,
            displayIndex,
            isExercise
        });

        setMenuOpen(false);
    };

    return (
        <li className="diary-section-item">
            <motion.div
                className={`list-item-layout ${menuOpen ? 'menu-open' : ''}`}
                animate={
                    hasItems
                        ? { borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }
                        : {
                              borderBottomLeftRadius: isSectionOpen ? 0 : 8,
                              borderBottomRightRadius: isSectionOpen ? 0 : 8
                          }
                }
                transition={{ duration: 0.15 }}
            >
                <div
                    className="item-icon-btn"
                    onClick={() =>
                        openModal(
                            { entryType: isExercise ? 'exercise' : entryType, mealId },
                            isExercise ? 'exercise' : 'default',
                            null,
                            { payload: { slotIndex } }
                        )
                    }
                >
                    <span className="icon-btn" style={{ backgroundColor: bgColor }}>
                        <img src={iconSrc} alt={`${title} icon`} />
                        <span className="plus-icon">
                            <img src="/assets/images/diary-icons/plus.svg" alt="Add icon" />
                        </span>
                    </span>
                </div>

                <div className="item-info" onClick={onToggleSection}>
                    <span className="bold-title">{title}</span>
                    {shouldShowLabel && (
                        <span className="item-label">
                            {recipeSlug ? (
                                <a href={`/recept/${recipeSlug}`} onClick={(e) => e.stopPropagation()}>
                                    {mealLabel}
                                </a>
                            ) : (
                                mealLabel
                            )}
                        </span>
                    )}
                </div>

                {shouldShowMenu && (
                    <div className={`item-controls ${menuOpen ? 'open' : ''}`}>
                        <span ref={toggleButtonRef} onClick={handleMenuToggle}>
                            <img src="/assets/images/diary-icons/ellipsis.svg" alt="Open menu" />
                        </span>

                        {menuOpen && (
                            <DiaryMenu
                                ref={menuRef}
                                entryType={entryType}
                                isExercise={isExercise}
                                isFavorite={Boolean(favoriteId)}
                                isAddedMeal={!isExercise && !isEmptySlot && mealId === null}
                                onMenuClick={handleMenuClick}
                                isDeletingFavorite={isDeletingFavorite}
                            />
                        )}
                    </div>
                )}
            </motion.div>

            <DiaryItemList
                isOpen={isSectionOpen}
                onOpenModal={(item) =>
                    openModal({}, 'itemNutrition', null, {
                        payload: item
                    })
                }
                items={items}
                isExercise={isExercise}
            />

            {hasItems && <DiarySum items={items} isExercise={isExercise} />}
        </li>
    );
};

export default DiarySectionItem;
